import styled from 'styled-components';
import { media } from '../../../constants/media/media';
import { withFancyScrollbar } from '../../../constants/styleUtils/styleUtils';
import { Columns } from '../../base/grid';
import DynamicRspImage from '../../base/images/dynamicRspImageBg';
import { H5 } from '../../base/typography';

export const Wrapper = styled.div<{ $highlighted?: boolean }>`
	box-shadow: 0px 14px 24px rgba(0, 0, 0, 0.1);
	outline: 2px solid ${({ $highlighted, theme }) => ($highlighted ? theme.colorsV2.mainPink : 'transparent')};
	outline-offset: -2px;
	transition: 0.3s;
	border-radius: 8px;
	overflow: hidden;
	&:hover {
		box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
	}
	cursor: pointer;
	width: 100%;
`;

export const Scrollable = styled(Columns)`
	margin-top: 2rem;
	${media.desktopSmall`
		max-height: 116rem;
		overflow-y: auto;
		${withFancyScrollbar};
	`};

	${media.desktopHuge`
		max-height: 84rem;
	`}
`;

export const InputWrapper = styled.div`
	display: flex;
	border-bottom: 1px solid ${({ theme }) => theme.colors.borderColor};
	padding-bottom: 0.1rem;
	margin-right: -2.7rem;
`;

export const OpeningHours = styled.div`
	padding: 2rem 4rem 2rem 4rem;
`;

export const LocationImage = styled.img`
	width: auto;
	height: 22rem;
	min-width: 100%;
	object-fit: cover;
	background-color: ${({ theme }) => theme.colors.grayLighter};
	background-image: url(${({ image }) => image}), url(${({ placeholderImage }) => placeholderImage});
`;

export const TextContainer = styled.div`
	padding: 2rem 4rem 0rem 4rem;
`;

export const InfoHeading = styled(H5)`
	margin: 1rem 0rem;
`;

export const Text = styled.p`
	margin-bottom: 0rem;
`;
export const Email = styled.a`
	color: ${({ theme }) => theme.colors.primary};
`;

export const ButtonWrapper = styled.div`
	margin-top: 3rem;
`;
